import React, { useState } from 'react';
import { TCITooltip } from '@/components/ui/Tooltip';
import * as Routes from 'modules/routes';
import { CopyModal } from '@/components/staffer/assessments/CopyLink';
import styles from './AssessmentRow/AssessmentRow.module.scss';
import { AssessmentInfo } from './types';

interface CopyButtonProps {
  assessment: AssessmentInfo;
  iconClass: string;
  programId: string | number;
  label?: string;
  showLabel?: boolean;
  withTooltip?: boolean;
}

const CopyButton = ({
  assessment, iconClass, programId, label = 'Make a Copy', showLabel = false, withTooltip = true,
}: CopyButtonProps) => {
  const [isOpen, setIsOpen] = useState(false);
  const closeModal = () => setIsOpen(false);

  const statusPath = Routes.plato_api_assessment_path(':assessment_id');
  const copyPath = Routes.copy_to_staffer_assessments_path({
    assessment_id: assessment.id,
    lesson_id: assessment.lesson_id,
    program_id: programId,
  });

  const button = (
    <button
      aria-controls="copyButton"
      aria-haspopup="dialog"
      aria-label={label}
      className={styles.active}
      type="button"
      onClick={() => setIsOpen(true)}
    >
      <i aria-hidden="true" className={`fa ${iconClass}`} />
      {showLabel && label}
    </button>
  );

  return (
    <>
      {withTooltip ? (
        <TCITooltip>
          <TCITooltip.Trigger asChild>{button}</TCITooltip.Trigger>
          <TCITooltip.Content>{label}</TCITooltip.Content>
        </TCITooltip>
      ) : button}
      <CopyModal
        ajaxPath={copyPath}
        closeModal={closeModal}
        modalIsOpen={isOpen}
        statusPath={statusPath}
        testName={assessment.name}
      />
    </>
  );
};

export default CopyButton;
